<div class="panel-group panel-group-control content-group-lg">

  <div class="panel">
      <div class="panel-body">

        <div class="form-group">


          <label class="radio-inline">
            <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="addType" (click)="switchView('station')" value="station" type="radio" name="radio-inline-left" class="styled choice" checked="checked">
            Add Station
          </label>

          <label class="radio-inline">
            <input [(ngModel)]="addType" (click)="switchView('device')" value="device" type="radio" name="radio-inline-left" class="styled choice">
            Add Device
          </label>

          <label class="radio-inline">
            <input [(ngModel)]="addType" (click)="switchView('parameter')" value="parameter" type="radio" name="radio-inline-left" class="choice styled">
            Add Parameter
          </label>
        </div>

        <div class="form-horizontal" *ngIf="addType == 'station'">
          <fieldset class="content-group">

            <legend class="text-semibold text-center"> Station details</legend>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Station Name*
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="stationDetails.name" placeholder="Enter station name" class="form-control">
                <div *ngIf="formErrorStationName && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorStationName}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Station Id*
                <div class="text-muted">(as maintained in vendor system)</div>
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="stationDetails.vendor_station_id" placeholder="Enter Station Id" class="form-control">
                <div *ngIf="formErrorStationId && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorStationId}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Station Type*
              </label>
              <div class="col-lg-10">
                <select [(ngModel)]="stationDetails['station_type']" class="form-control">
                  <option value=""> Select Station Type </option>
                  <option value="Emission"> Emission </option>
                  <option value="Effluent"> Effluent </option>
                </select>

                <div *ngIf="formErrorStationType && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorStationType}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Contact Person Name
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="stationDetails['contact_person']" placeholder="Enter Contact Person Name" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Contact Person Designation
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="stationDetails['contact_person_designation']" placeholder="Enter Contact Person Designation" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Contact Person Email
              </label>
              <div class="col-lg-10">
                <input type="email" [(ngModel)]="stationDetails['contact_email']" placeholder="Enter Contact Person Email" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Contact Person Mobile Number
              </label>
              <div class="col-lg-10">
                <input  type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [(ngModel)]="stationDetails['contact_number']" placeholder="Enter Contact Person Mobile Number" class="form-control">
              </div>
            </div>

          </fieldset>
        </div>

        <div class="form-horizontal" *ngIf="addType == 'station' || addType == 'device'">

          <fieldset class="content-group">

            <legend class="text-center text-semibold"> Device details</legend>

            <div class="form-group" *ngIf="addType == 'device'">
              <label class="control-label col-lg-2">
                Select Station*
              </label>
              <div class="col-lg-10">

                <select [(ngModel)]="deviceDetails['station_id']" class="form-control">
                  <option value=""> Select Station </option>
                  <option value="{{station.id}}" *ngFor="let station of allStationList"> {{station.name}} </option>
                </select>
                <div *ngIf="formErrorStationIdLink && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorStationIdLink}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Device Id*
                <div class="text-muted">(as maintained in vendor system)</div>
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="deviceDetails['name']" placeholder="Enter device Id" class="form-control">
                <div *ngIf="formErrorDeviceId && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorDeviceId}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Data Frequency
                <div class="text-muted">Enter value in minute</div>
              </label>
              <div class="col-lg-10">
                <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [(ngModel)]="deviceDetails['frequency']" placeholder="Enter data frequency" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Make
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="deviceDetails['make_name']" placeholder="Enter device make name" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Model
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="deviceDetails['model_name']" placeholder="Enter device model" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Serial Number
              </label>
              <div class="col-lg-10">
                <input type="email" [(ngModel)]="deviceDetails['actual_serial_no']" placeholder="Enter device serial number" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Certification System Type
              </label>
              <div class="col-lg-10">
                <input type="email" [(ngModel)]="deviceDetails['certification']" placeholder="Enter certification system type" class="form-control">
              </div>
            </div>

          </fieldset>
        </div>

        <div class="form-horizontal" *ngIf="addType == 'station' || addType == 'parameter' || addType == 'device'">

          <fieldset class="content-group">

            <legend class="text-semibold text-center"> Parameter details</legend>


            <div class="form-group" *ngIf="addType == 'parameter'">
              <label class="control-label col-lg-2">
                Select Devcie*
              </label>
              <div class="col-lg-10">

                <select [(ngModel)]="parameterDetails['device_id']" class="form-control">
                  <option value=""> Select Device </option>
                  <option value="{{device.id}}" *ngFor="let device of allDeviceList"> {{device.name}} </option>
                </select>
                <div *ngIf="formErrorDeviceIdLinked && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorDeviceIdLinked}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Parameter Name*
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="parameterDetails['paramkey']" placeholder="Enter parameter name" class="form-control">
                <div *ngIf="formErrorParameterName && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorParameterName}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Units*
              </label>
              <div class="col-lg-10">
                <input type="text" [(ngModel)]="parameterDetails['stdunit']" placeholder="Enter units" class="form-control">
                <div *ngIf="formErrorUnit && error">
                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorUnit}}</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Min value
              </label>
              <div class="col-lg-10">
                <input type="number" onkeypress="return  event.charCode <= 57" [(ngModel)]="parameterDetails['min']" placeholder="Enter min value" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-lg-2">
                Max value
              </label>
              <div class="col-lg-10">
                <input type="number" onkeypress="return event.charCode <= 57 " [(ngModel)]="parameterDetails['max']" placeholder="Enter max value" class="form-control">
              </div>
            </div>

          </fieldset>
        </div>


        <div class="form-horizontal">

          <fieldset class="content-group">
            <div class="form-group">
              <div class="col-lg-12" *ngIf="!addDetailLoader">

                <div class="col-lg-1 pull-right">
                  <button (click)="validateDetails()" type="submit" class="btn btn-primary">
                    <strong>Add</strong>
                  </button>
                </div>

                <div class="col-lg-1 pull-right">
                  <button (click)="resetDetails()" type="button" class="btn btn-danger">
                    <strong>Reset</strong>
                  </button>
                </div>
              </div>

              <div class="col-lg-12" *ngIf="addDetailLoader">
                <span class="pull-right"><img style="width: 60%;" src="/assets/images/load.gif" /></span>
              </div>
            </div>
          </fieldset>
        </div>

      </div>
  </div>

</div>
<!-- /collapsible with left control button -->
